import { useState } from "react";
import { Link } from "react-router-dom";
import Menu from "components/Menu";
import Icon from "components/general/Icon";
import AssignShift from "components/modals/AssignShift";
import RecalculateShift from "components/modals/Recalculate/RecalculateShift";
import showSuccessMsg from "utils/showSuccessMsg";
import { useDeleteAssignedShiftMutation } from "apis/services/shift";
import useGetUserInfo from "hooks/useGetUserInfo";
import styles from "./styles.module.scss";
import usePermissions from "hooks/usePermission";

export default function StaffAction({
  containerStyle,
  employee,
  shift,
  assignType,
  isEditDisabled,
}: any) {
  const [isDetailsShown, setIsDetailsShown] = useState(false);
  const [isRecalculateShown, setIsRecalculateShown] = useState(false);
  const [deleteAssignedShift] = useDeleteAssignedShiftMutation();
  const { hasPermissionTo } = usePermissions()
  //update_my_staff_shift
  const update_my_staff_shift = hasPermissionTo("update_my_staff_shift")
  // Recalculate and delete answer to their own endpoint permissions now, so
  // editing a shift no longer carries the right to recalculate or delete it.
  const canRecalculate = hasPermissionTo("recalculate_shifts")
  const canDeleteShift = hasPermissionTo("delete_shifts")
  const onDeleteShift = () => {
    deleteAssignedShift(shift?.id)
      .unwrap()
      .then(() => {
        showSuccessMsg({ msg: "Delete shift successfully!" });
      });
  };

  const MenuData =
    [
      {
        key: "profile",
        label: <Link to={`/staff/${employee?.id}`}>View Profile</Link>,
      },
      {
        key: "edit_assign",
        disabled: !update_my_staff_shift || (assignType === "based" && isEditDisabled),
        label: (
          <button
            onClick={() => setIsDetailsShown(true)}
            className={styles.memberActionBtn}
            disabled={!update_my_staff_shift || (assignType === "based" && isEditDisabled)}
          >
            Edit Shift
          </button>
        ),
      },
      {
        key: "recalculate_shift",
        disabled: !canRecalculate,
        label: (
          <button
            onClick={() => setIsRecalculateShown(true)}
            className={styles.memberActionBtn}
            disabled={!canRecalculate}
          >
            Recalculate shift
          </button>
        ),
      },
      {
        key: "delete_assign",
        disabled: !canDeleteShift,
        label: (
          <button
            onClick={onDeleteShift}
            className={styles.memberActionBtn}
            disabled={!canDeleteShift}
          >
            Delete Shift
          </button>
        ),
      },
    ];

  return (
    <div className={`${styles.container} ${containerStyle}`}>
      <Menu items={MenuData}>
        <button className={styles.memberActionBtn}>
          <Icon name="Menu" size={24} color="info" />
        </button>
      </Menu>
      {isDetailsShown && employee && (
        <AssignShift
          isVisible={isDetailsShown}
          setIsVisible={() => setIsDetailsShown(false)}
          user={employee}
          assignType={assignType}
          initialValues={shift}
          isUpdate
        />
      )}
      {isRecalculateShown && (
        <RecalculateShift
          isVisible={isRecalculateShown}
          setIsVisible={setIsRecalculateShown}
          shift={shift}
          employee={employee}
        />
      )}
    </div>
  );
}
